import styled from 'styled-components';
//////////////////////////////////////////////////

const LoaderWrapper = styled.div`
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  z-index: 9999;
  position: fixed;
  cursor: progress;
  align-items: center;
  justify-content: center;

  background: ${({ theme }) => theme.background.loaderWrapper};
`;

export {
  LoaderWrapper,
};
